import React from 'react';
import { motion } from 'framer-motion';
import { SparkleIcon, ClockIcon } from './Icons';
export function ProofSection() {
  return <section className="w-full bg-white-soft py-10 md:py-24 px-5" data-id="element-447">
      <div className="max-w-2xl mx-auto" data-id="element-448">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-7 md:mb-12" data-id="element-449">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-gold/10 mb-5" data-id="element-450">
            <SparkleIcon className="w-7 h-7 text-gold" data-id="element-451" />
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-brown-dark" data-id="element-452">
            Resultados Que Puedes Esperar
          </h2>
        </motion.div>

        <div className="space-y-6" data-id="element-453">
          {/* 7 days */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bg-cream rounded-xl p-6 md:p-8 border border-gold/20 relative overflow-hidden" data-id="element-454">
            <div className="absolute top-0 left-0 w-1.5 h-full bg-gold" data-id="element-455" />
            <div className="flex items-start gap-4" data-id="element-456">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-gold/15 flex items-center justify-center" data-id="element-457">
                <ClockIcon className="w-5 h-5 text-gold" data-id="element-458" />
              </div>
              <div data-id="element-459">
                <h3 className="font-heading text-lg font-bold text-brown-dark mb-2" data-id="element-460">
                  En los primeros 7 días
                </h3>
                <p className="font-body text-base text-brown-medium leading-relaxed" data-id="element-461">
                  Notarás que la almohada amanece limpia. El picor desaparece en
                  la primera aplicación.
                </p>
              </div>
            </div>
          </motion.div>

          {/* 30 days */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: 0.25
        }} className="bg-cream rounded-xl p-6 md:p-8 border border-gold/20 relative overflow-hidden" data-id="element-462">
            <div className="absolute top-0 left-0 w-1.5 h-full bg-sage" data-id="element-463" />
            <div className="flex items-start gap-4" data-id="element-464">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-sage/15 flex items-center justify-center" data-id="element-465">
                <SparkleIcon className="w-5 h-5 text-sage" data-id="element-466" />
              </div>
              <div data-id="element-467">
                <h3 className="font-heading text-lg font-bold text-brown-dark mb-2" data-id="element-468">
                  Para el día 30
                </h3>
                <p className="font-body text-base text-brown-medium leading-relaxed" data-id="element-469">
                  El brillo regresa y las zonas donde el cuero cabelludo se veía
                  "rojo o irritado" recuperan su tono saludable, señal de que el
                  folículo está listo para volver a producir.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}